<template>
    <transition name="fade" mode="out-in">
        <loader v-if="loading"></loader>
        <form v-else @submit.prevent="submitForm" class="quotetool__step">
            <div class="container">
                <h2 class="quotetool__step-heading">
                    {{ labels.stepOneTitle }}
                </h2>
                <div class="quotetool__step-form-container">
                    <!-- Business name -->
                    <div class="form-group" :class="{ 'form-group--error': $v.businessName.$error }">
                        <label for="businessName">{{ labels.stepOneBusinessNameLabel }} *</label>
                        <input v-model.trim="$v.businessName.$model" type="text" class="form-control" id="businessName" :placeholder="labels.stepOneBusinessNamePlaceholder">
                    </div>

                    <div class="error" v-if="!$v.businessName.required">{{ labels.stepOneBusinessNameValidationMsg }}</div>

                    <!-- Title | First name | Last name -->
                    <div class="form-group" :class="{ 'form-group--error': $v.title.$error || $v.firstName.$error || $v.lastName.$error }">
                        <label>{{ labels.stepOneFullNameLabel }}*</label>
                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="custom-select">
                                    <select v-model.trim="$v.title.$model" type="text" class="form-control">
                                        <option value="mr">Mr</option>
                                        <option value="mrs">Mrs</option>
                                        <option value="ms">Ms</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <input v-model.trim="$v.firstName.$model" type="text" class="form-control" :placeholder="labels.stepOneFirstNamePlaceholder">
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <input v-model.trim="$v.lastName.$model" type="text" class="form-control" :placeholder="labels.stepOneLastNamePlaceholder">
                            </div>
                        </div>
                    </div>

                    <div class="error" v-if="!$v.title.required">{{ labels.stepOneFullNameValidationMsg }}</div>
                    <div class="error" v-if="!$v.firstName.required">{{ labels.stepOneFullNameValidationMsg }}</div>
                    <div class="error" v-if="!$v.lastName.required">{{ labels.stepOneFullNameValidationMsg }}</div>

                    <!-- Email -->
                    <div class="form-group" :class="{ 'form-group--error': $v.email.$error }">
                        <label for="email">{{ labels.stepOneEmailAddressLabel }}*</label>
                        <input v-model.trim="$v.email.$model" type="email" class="form-control" id="email" :placeholder="labels.stepOneEmailAddressPlaceholder">
                    </div>

                    <div class="error" v-if="!$v.email.required">E-mail is required</div>
                    <div class="error" v-if="!$v.email.email">E-mail format is invalid</div>

                    <!-- Main phone -->
                    <div class="form-group" :class="{ 'form-group--error': $v.mainPhoneNumber.$error }">
                        <label for="mainPhoneNum">{{ labels.stepOneMainPhoneNumberLabel }}*</label>
                        <input v-model.trim="$v.mainPhoneNumber.$model" type="text" class="form-control" id="mainPhoneNum">
                    </div>

                    <div class="error" v-if="!$v.mainPhoneNumber.required">{{ labels.stepOneMainPhoneNumberValidationMsg }}</div>
                    <div class="error" v-if="!$v.mainPhoneNumber.numeric">{{ labels.stepOneMainPhoneNumberValidationMsg }}</div>

                    <!-- Alternative phone -->
                    <div class="form-group">
                        <label for="alternativePhoneNum">{{ labels.stepOneAlternativePhoneNumberLabel }}</label>
                        <input v-model="altPhoneNumber" type="text" class="form-control" id="alternativePhoneNum">
                    </div>

                    <!-- Authorisation -->
                    <div class="checkbox" :class="{ 'form-group--error': $v.decisionAuthorisation.$error }">
                        <label>
                            <input v-model="$v.decisionAuthorisation.$model" type="checkbox" :value="true">
                            {{ labels.stepOneAuthorisationConfirmationLabel }}*
                            <span class="checkmark"></span>
                        </label>
                    </div>

                    <div class="error" v-if="!$v.decisionAuthorisation.required">This field is required</div>
                    <div class="error" v-if="!$v.decisionAuthorisation.isTrue">This field is required</div> 

                    <!-- Quote type -->
                    <div class="form-group radio-group" :class="{ 'form-group--error': $v.quoteType.$error }">
                        <label>{{ labels.stepOneQuoteTypeLabel }}*</label>
                        <div>
                            <label class="radio-inline">
                                <input v-model="$v.quoteType.$model" type="radio" name="quoteType" id="quoteTypeNew" value="new"> {{ labels.stepOneNewQuoteRadioLabel }}
                                <span class="checkmark"></span>
                            </label>
                            <label class="radio-inline">
                                <input v-model="$v.quoteType.$model" type="radio" name="quoteType" id="quoteTypeExisting" value="existing"> {{ labels.stepOneExistingCustomerRadioLabel }}
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>

                    <div class="error" v-if="!$v.quoteType.required">This field is required</div>

                    <!-- Policy accept -->
                    <div class="form-group" :class="{ 'form-group--error': $v.hasAcceptedPolicy.$error }">
                        <label>
                            {{ labels.stepOneSaveDetailsLabel }}
                        </label>
                        <div class="checkbox">
                            <label>
                                <input v-model="$v.hasAcceptedPolicy.$model" type="checkbox" :value="true">
                                {{ labels.stepOneSaveDetailsCheckboxLabel }}*
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>

                    <div class="error" v-if="!$v.hasAcceptedPolicy.required">{{ labels.stepOneSaveDetailsCheckboxValidationMsg }}</div>
                    <div class="error" v-if="!$v.hasAcceptedPolicy.isTrue">{{ labels.stepOneSaveDetailsCheckboxValidationMsg }}</div>

                    <button class="btn--chevron" @click.prevent="submit">{{ labels.stepOneSubmitButtonLabel }}</button>
                </div>

            </div>
            <section class="section--light-blue">
                <div class="container container--max-width-1010 text-center">
                    <h2 class="quotetool__step-heading">                      
                        {{ labels.stepOneWhatOurCustomersSayHeading }}
                    </h2> 
                    <p class="font-26">{{ labels.stepOneWhatOurCustomersSayContent }} </p>
                </div>
            </section>
        </form>
    </transition>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import { createHelpers } from 'vuex-map-fields';
    import { required, email, numeric } from 'vuelidate/lib/validators';

    import StepNavigation from '../StepNavigation.vue';
    import Loader from '../Loader.vue';

    const { mapFields } = createHelpers({
        getterType: 'informationStep/getField',
        mutationType: 'informationStep/updateField',
    });

    export default {
        components: {
            StepNavigation,
            Loader
        },

        data() {
            return {
                submittingForm: false,
                loading: false,
            }
        },

        computed: {
            ...mapFields([
                'businessName',
                'title',
                'firstName',
                'lastName',
                'email',
                'mainPhoneNumber',
                'altPhoneNumber',
                'decisionAuthorisation',
                'quoteType',
                'customerReferenceNumber',
                'hasAcceptedPolicy'
            ]),

            ...mapState('microcopy', [
                'labels',
            ]),

            isExistingQuote() {
                return this.quoteType == 'existing';
            }
        },

        methods: {
            ...mapActions('informationStep', {
                submitForm: 'submit',
            }),

            /**
             * Submits the form, dispatches the submit action if the form is valid.
             * */
            submit() {
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    this.loading = true;
                    this.submitForm().then(data => {
                        this.loading = false;
                    });
                }
            }
        },

        validations: {

            businessName: {
                required,
            },

            title: {
                required,
            },

            firstName: {
                required,
            },

            lastName: {
                required,
            },

            email: {
                required,
                email
            },

            mainPhoneNumber: {
                required,
                numeric
            },

            decisionAuthorisation: {
                required,
                isTrue: (value) => {
                    return value == true;
                }
            },

            quoteType: {
                required,
            },

            hasAcceptedPolicy: {
                required,
                isTrue: (value) => {
                    return value == true;
                }
            }

        }
    }
</script>